
/**
 * 負荷軽減のためtimeoutでcallbackはやめた
 */
export default function scrollEvent(callback){
  window.addEventListener('scroll',() => {
    /*
    clearTimeout(timer)
    const timer = setTimeout(() => {
      callback()
    },200)
    */
   callback()
  })
}



// WEBPACK FOOTER //
// ./src/component/scrollEvent.js